import userRoles from 'constants/user-roles.constant';
import {
  HUB_RESTRICTIONS,
  wellBeingHub,
  RECOMMENDATION_RESTRICTIONS,
  wellBeingRecommendations,
} from './well-being-hub.constants';

const resolver = () =>
  import(/* webpackChunkName: "well-being-hub" */ './well-being-hub.container');

const wellbeingUrl = '/wellbeing';

const wellBeingHubModule = {
  hub: {
    name: wellBeingHub,
    url: wellbeingUrl,
    resolver,
    restrictions: HUB_RESTRICTIONS,
    data: {
      title: 'components.main_menu.well_being_hub',
      mainMenu: wellBeingHub,
      section: 'wellBeing',
      includeInMenu: true,
      authorizedRoles: [userRoles.employee],
    },
  },
  recommendations: {
    name: wellBeingRecommendations,
    url: `${wellbeingUrl}/recommendations`,
    resolver,
    restrictions: RECOMMENDATION_RESTRICTIONS,
    data: {
      title: 'components.main_menu.well_being_hub',
      mainMenu: wellBeingRecommendations,
      section: 'wellBeing',
      includeInMenu: false,
      authorizedRoles: [userRoles.employee],
    },
  },
};

export default wellBeingHubModule;
